import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const application = Application.start();
const context = require.context("features/", true, /^\.\/blog\/.*\.js/);
application.load(definitionsFromContext(context));
